import { render, staticRenderFns } from "./guns.vue?vue&type=template&id=74b651b0&scoped=true"
var script = {}
import style0 from "./guns.vue?vue&type=style&index=0&id=74b651b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b651b0",
  null
  
)

export default component.exports